<template>
  <div>
    <el-form :model="form" ref="form" label-position="left" label-width="120px">
      <el-form-item label="供应商">
        <el-select v-model="form.suply" placeholder="全部" clearable>
          <el-option
            v-for="item in supplyList"
            :key="item._id"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.type" placeholder="全部" clearable>
          <el-option label="在线" value="在线"></el-option>
          <el-option label="离线" value="离线"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="过期时间" prop="deadtime">
        <el-date-picker
          v-model="form.deadtime"
          format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-button @click="freshData" type="primary" style='margin-left:20px'>查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="time_text" label="上报时间" sortable></el-table-column>
      <el-table-column prop="cloud_server" label="云主机名"></el-table-column>
      <el-table-column prop="serial" label="序列号"></el-table-column>
      <el-table-column prop="p_ip" label="公网IP"></el-table-column>
      <el-table-column prop="user_count" label="实时连接数"></el-table-column>
      <el-table-column prop="srv" label="srv"></el-table-column>
      <el-table-column prop="suply" label="供应商"></el-table-column>
      <el-table-column prop="isp_addr" label="运营商"></el-table-column>
      <el-table-column prop="cc" label="国家"></el-table-column>
      <el-table-column prop="province" label="省份"></el-table-column>
      <el-table-column prop="city" label="地区"></el-table-column>
      <el-table-column prop="flow" label="手机卡总流量"></el-table-column>
      <el-table-column prop="flow_left" label="剩余流量"></el-table-column>
      <el-table-column prop="flow_date_text" label="过期时间"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column prop="tag" label="备注"></el-table-column>
      <el-table-column prop="vip" label="节点类型">
          <template slot-scope="scope">
            <span>{{scope.row.vip == 2 ? '专线' : '共享'}}</span>
          </template>
      </el-table-column>
      <el-table-column prop="enable" label="开关">
          <template slot-scope="scope">
              <el-switch 
                v-model="scope.row.enable" 
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="2"
                inactive-color="#ccc"
                @change='switchChange(scope.row)'
              >
              </el-switch>
          </template>
      </el-table-column>
      <el-table-column prop="is_online" label="当前状态">
          <template slot-scope="scope">
            <span>
                <el-button v-if="((scope.row.time + 180)*1000 > Date.now())" type="success">在线</el-button>
                <el-button v-if="((scope.row.time + 180)*1000 <= Date.now())" type="danger">离线</el-button>
            </span>
          </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)">编辑</el-button>
          <el-button @click="deleteID(scope.row._id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑 -->
    <Edit v-if="editDialogFlag" :dialogVisible.sync="editDialogFlag" :dialogData="editDialogData" @freshData='freshData'/>
  </div>
</template>

<script>
import { static_vps, static_vps_delete, static_vps_edit, supply_list } from "@/request/api.js";
import Edit from "./components/StaticNode/edit.vue";
export default {
  components: {
    Edit
  },
  created(){
    this.freshData()
    this.getSupplyList()
  },
  data() {
    return {
      form: {},
      tableData: [],
      editDialogData: {}, //套餐编辑
      editDialogFlag: false,
      addDialogFlag: false,
      supplyList:[],
    };
  },
  methods: {
    freshData(){
      // console.log(this.form);
      // return
      let params = {
        ...this.form
      }
      if(this.form.deadtime){
        params.time_start = this.form.deadtime ? ((this.form.deadtime[0])/1000): ""
        params.time_end = this.form.deadtime ? ( 86400+(this.form.deadtime[1])/1000 ) : ""
      }
      delete params.deadtime
      static_vps(params).then(
        (res) => {
          if (res.status == 0) {
            this.$message.success('获取成功');
            res.detail.forEach((item)=>{
              item.time_text = this.detailtime(item.time*1000)
              item.flow_date = item.flow_date*1000
              item.flow_date_text = this.detailtime(item.flow_date)
            })
            this.tableData = res.detail;
            this.total = res.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      );
    },
    //编辑
    edit(row) {
      this.editDialogFlag = true;
      this.editDialogData = row;
    },
    // 删除
    deleteID(id) {
      // console.log(id);
      // return
      this.$alert("你正在进行删除操作", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if(action=='confirm'){
            static_vps_delete({id}).then(
              (res) => {
                if (res.status == 0) {
                  this.$message.success(res.detail);
                  this.freshData()
                }
              }
            );
          }
        }
      });
    },
    //开关切换
    switchChange(row) {
      let params = {
        id:row._id,
        enable:row.enable
      }
      static_vps_edit(params).then(
        (res) => {
          if (res.status == 0) {
            this.$message.success(res.detail);
            this.freshData()
          }else{
            this.$message.error(res.detail);
          }
        }
      );
    },
    getSupplyList(){
      supply_list().then(
        (res) => {
          if (res.status == 0) {
            this.supplyList = res.detail;
          } else {
            this.$message.error('供应商列表获取失败')
            this.supplyList = [];
          }
        }
      );
    },
  }
};
</script>

<style>
</style>